export const endpoints = {
  accountSettings: '/account-settings',
  accounts: '/accounts/:id',
  accountsSignUp: '/accounts/signup',
  analytics: {
    businessUpdates: '/listings/business-updates',
    customerInteractions: '/analytics/customer-interactions',
    searchAppearances: '/analytics/search-appearances',
    keywords: '/analytics/search-appearances/keywords',
    searchAppearancesByMonth: '/analytics/search-appearances-by-month',
  },
  choices: '/choices',
  connectedIntegrations: '/connected-integrations',
  guestConnect: {
    firstPartyReview: {
      byId: '/guest-connect/first-party-review/:id',
    },
  },
  items: '/items',
  labels: {
    getAll: '/labels',
    addLabel: '/labels',
    updateLabel: '/labels/:id',
    deleteLabel: '/labels/:id',
  },
  listings: {
    create: '/listings',
    delete: '/listings/:id',
    forceSync: '/listings/:id/force-sync-store',
    getAll: '/listings',
    getById: '/listings/:id/recent',
    getGoogleAccounts: '/listings/google/accounts',
    getGoogleLocations: '/listings/google/locations',
    getYelpAccounts: '/listings/yelp/businesses',
    getFacebookAccounts: '/listings/facebook/accounts',
    disable: '/listings/yext/:id/optout',
    enable: '/listings/yext/:id/optin',
  },
  managedReviews: {
    getAllTones: '/managed-reviews/tones',
    prompts: {
      generateResponse: '/managed-reviews/prompts/review-response/generate',
      getResponseByReviewId: '/managed-reviews/prompts/review',
    },
    settings: {
      getByReviewId: '/managed-reviews/settings/review/:id',
      newGetByReviewId: '/managed-reviews/settings-new/review/:id',
      getAll: '/managed-reviews/settings',
      getById: '/managed-reviews/settings/:id',
      newGetById: '/managed-reviews/settings-new/:id',
      delete: '/managed-reviews/settings/:id',
      create: '/managed-reviews/settings',
      edit: '/managed-reviews/settings',
    },
    availableFolders: '/managed-reviews/folders/available-for-settings',
    availableStores: '/managed-reviews/stores/available-for-settings',
    quotas: {
      getByReviewId: '/managed-reviews/quotas/review/:id',
    },
  },
  marketIntelligence: {
    getStores: '/competitors/stores',
    getStoresSummary: '/competitors/stores/summary',
    getStoreDetails: '/competitors/stores/:storeId/competitors-details',
    replaceCompetitor: '/competitors/stores/:storeId/competitors/replace',
  },
  media: {
    storeLocation: {
      image: '/store-locations-media',
    },
    socialPosts: {
      image: '/store-locations-media/social-posts/image',
      video: '/store-locations-media/social-posts/video',
    },
    widgets: {
      image: '/store-locations-media/embeddables/logo',
    },
  },
  menus: '/menus',
  menuTrees: '/menus/tree',
  modifiers: '/modifiers',
  oauth: '/oauth',
  premiumFeatures: '/premium/features',
  reviews: '/reviews',
  reviewsOverview: {
    publishersDistribution: '/reviews/overview/providers-distribution',
    ratings: '/reviews/overview/ratings-distribution',
    awaitingReplies: '/reviews/overview/awaiting-replies',
  },
  reviewsInsights: {
    providerAnalysis: '/reviews/insights/provider-analysis',
    sentimentAnalysis: '/reviews/insights/provider-sentiments',
    sentimentTrend: '/reviews/insights/sentiment-trend-analysis',
    storePerformances: '/reviews/insights/store-performances',
    storePerformancesByRating: '/reviews/insights/store-performances-by-rating',
    keywordMentions: '/reviews/insights/keyword-mentions',
    trendingKeywords: '/reviews/insights/trending-keywords',
    keywordPerformance: '/reviews/insights/keywords-performance',
    locationPerformance: '/reviews/insights/locations-performance',
    trendingThemes: '/reviews/insights/trending-themes',
    drawer: {
      summary: '/reviews/insights/drawer/summary',
      reviews: '/reviews/insights/drawer/reviews',
      aiSummary: '/managed-reviews/prompts/reviews-summary/generate',
    },
  },
  roles: {
    userRoles: '/roles/user-roles',
    permissions: '/roles/permissions',
  },
  sections: '/sections',
  storeFolders: '/store-locations/folders',
  storeLocationCategories: '/store-locations/categories',
  storeLocations: '/store-locations',
  templates: {
    getAll: '/templates',
    getById: '/templates/:id',
    addTemplate: '/templates',
    editTemplate: '/templates/:id',
    deleteTemplate: '/templates/:id',
  },
  users: '/users',
  notifications: {
    getAll: '/notifications',
    getById: '/notifications/:id',
    create: '/notifications',
    edit: '/notifications/:id',
    delete: '/notifications/:id',
  },
  socialManagement: {
    pages: {
      forceSyncPagesFromLoggedAccount: '/social-posts/pages/authorized-connection/force-sync',
      getEnabledPages: '/social-posts/pages/enabled',
      getPagesByAuthorizedConnection: '/social-posts/pages/authorized-connection/:id',
      updateEnabledPages: '/social-posts/page-settings',
    },
    posts: {
      addPostMedia: '/social-posts/medias',
      apple: {
        validatePostOverlapping: '/social-posts/posts/apple/:postId/validate',
      },
      createDraft: '/social-posts/posts/draft',
      createPost: '/social-posts/posts',
      deletePost: '/social-posts/post-provider/:id',
      deleteApplePosts: '/social-posts/posts/apple/:id',
      deleteScheduled: '/social-posts/posts/:scheduledId',
      deleteDraft: '/social-posts/posts/:draftId',
      getAllDrafts: '/social-posts/posts/draft',
      getAllPublished: '/social-posts/posts/published',
      getAllScheduled: '/social-posts/posts/scheduled',
      getPostById: '/social-posts/posts/:postId',
      getPostDetailsById: '/social-posts/post-provider/:id',
      getPostInsightsById: '/social-posts/post-provider/:id/insights',
      publishPost: '/social-posts/posts/:postId/publish',
      rePublishPost: '/social-posts/post-provider/:id/re-publish',
      schedulePost: '/social-posts/posts/:postId/schedule',
      updateDraft: '/social-posts/posts/draft',
      updatePost: '/social-posts/posts',
    },
    storeListings: {
      getByPublisher: '/social-posts/store-listings',
      getAppleCTAsByStoreListing: '/social-posts/store-listings/:storeListingId/apple-ctas',
    },
  },
  providerCategories: '/store-locations/provider-categories',
  categoriesOverride: '/store-locations/:locationId/category-override',
  widgets: {
    getAll: '/embeddables/widgets',
    hour: {
      create: '/embeddables/hours-widgets',
      update: '/embeddables/hours-widgets/:id',
      delete: '/embeddables/hours-widgets/:id',
      getById: '/embeddables/hours-widgets/:id',
    },
    menu: {
      create: '/embeddables/menus-widgets',
      update: '/embeddables/menus-widgets/:id',
      getById: '/embeddables/menus-widgets/:id',
      delete: '/embeddables/menus-widgets/:id',
    },
    reviewForm: {
      getAll: '/embeddables/review-forms-widgets',
      create: '/embeddables/review-forms-widgets',
      update: '/embeddables/review-forms-widgets/:id',
      getById: '/embeddables/review-forms-widgets/:id',
      delete: '/embeddables/review-forms-widgets/:id',
    },
    presets: {
      getAll: '/embeddables/presets',
    },
  },
  omni: {
    getProviderAttributes: '/omni/stores/:storeLocationId/provider-attributes',
  },
  reviewGeneration: {
    performanceSummary: '/guest-connect/performance',
    eligibleLocations: '/guest-connect/locations/eligible',
  },
}

export const mockEndpoints = {
  login: 'https://cognito-idp.us-east-1.amazonaws.com',
}
